import React from 'react';
import { Toaster } from 'react-hot-toast';
import FileViewer from '../../../components/FileViewer';
import UserMenuPopover from '../../../components/UserMenuPopover';
import UserSettingsModal from '../../../components/UserSettingsModal';
import VoiceDebugPanel from '../../../components/VoiceDebugPanel';
import PaywallModal from '../../../components/PaywallModal';
import PromotionPopup from '../../../components/PromotionPopup';
import UnavailableModal from '../../../components/UnavailableModal';
import LimitReachedModal from '../../../components/LimitReachedModal';
import { isAuthenticated } from '../../../utils/api';

const TOAST_OPTIONS = {
    duration: 5000,
    style: {
        marginTop: '50px',
        background: '#FFFBFB',
        border: '1px solid #FEE2E2',
        color: '#991B1B',
        borderRadius: '0.5rem',
        padding: '12px 16px',
        fontSize: '14px',
        minWidth: '280px',
        maxWidth: '500px',
        textAlign: 'left',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)',
    },
};

export default function ChatModals({
    viewingAttachment,
    setViewingAttachment,
    activeSessionId,
    sharedInfo,

    isUserMenuOpen,
    setIsUserMenuOpen,
    currentUser,
    onOpenSettings,
    onLogout,

    isUserSettingsOpen,
    setIsUserSettingsOpen,
    settingsDefaultTab,
    setSettingsDefaultTab,

    injectVoiceInputFile,
    isVoiceInputRecording,

    showPaywall,
    setShowPaywall,
    errorLimitInfo,
    budgetStatus,

    showPromotionPopup,
    setShowPromotionPopup,
    checkUsageStatus,

    showUnavailable,
    setShowUnavailable,

    showLimitReached,
    setShowLimitReached,
}) {
    return (
        <>
            {viewingAttachment && (
                <FileViewer
                    file={viewingAttachment}
                    sessionId={activeSessionId || sharedInfo?.session_id}
                    onClose={() => setViewingAttachment(null)}
                />
            )}

            {/* UserMenuPopover lives at ``ChatLayout`` level so it works on
                every routed page (chat + insights + …). Rendering it here
                would duplicate the popover on chat routes. */}

            <UserSettingsModal
                isOpen={isUserSettingsOpen}
                user={currentUser}
                defaultTab={settingsDefaultTab}
                onClose={() => {
                    setIsUserSettingsOpen(false);
                    setSettingsDefaultTab('profile');
                }}
            />

            <Toaster position="top-right" limit={1} toastOptions={TOAST_OPTIONS} />

            <VoiceDebugPanel onSendFile={injectVoiceInputFile} isRecording={isVoiceInputRecording} />

            <PaywallModal
                open={showPaywall}
                onClose={() => setShowPaywall(false)}
                tier={errorLimitInfo?.tier || budgetStatus?.tier}
                deniedBy={errorLimitInfo?.deniedBy || budgetStatus?.denied_by}
                budgetStatus={budgetStatus}
            />

            {isAuthenticated() && showPromotionPopup && (
                <PromotionPopup
                    onClose={() => setShowPromotionPopup(false)}
                    onClaimed={() => checkUsageStatus()}
                />
            )}

            {showUnavailable && <UnavailableModal onClose={() => setShowUnavailable(false)} />}

            {showLimitReached && (
                <LimitReachedModal
                    onClose={() => setShowLimitReached(false)}
                    onViewDetails={() => {
                        setShowLimitReached(false);
                        setSettingsDefaultTab('usage');
                        setIsUserSettingsOpen(true);
                    }}
                />
            )}
        </>
    );
}
